import React, { useState } from "react";
import { InputMask } from "@react-input/mask";
import Dialog, {
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "components/Dialog/Dialog";
import Button from "components/Button/Button";
import { FormFeedback, FormLabel, FormRow } from "components/Form/Form";
import formStyles from "components/Form/Form.module.scss";
import { googlePropagate, handleAuthRedirect } from "services";
import toast from "react-hot-toast";

export default function GoogleCpfModal({ isOpen, onClose, googleCredential }) {
  const [cpf, setCpf] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const rawCpf = cpf.replace(/\D/g, "");
    if (rawCpf.length !== 11) {
      setError("Informe um CPF válido.");
      return;
    }

    setLoading(true);
    const response = await googlePropagate(googleCredential, rawCpf);
    setLoading(false);

    if (response?.status === 200) {
      toast.success("Conta criada com sucesso!");
      handleAuthRedirect(response.data);
      return;
    }

    const msg = response?.data?.error;

    if (response?.status === 404) {
      setError(
        "CPF não encontrado no iSeduc. Entre em contato com sua escola para verificar seu cadastro.",
      );
    } else if (response?.status === 409) {
      setError(msg || "Este CPF já está cadastrado.");
    } else {
      setError(msg || "Erro ao realizar o cadastro. Tente novamente.");
    }
  };

  const handleClose = () => {
    setCpf("");
    setError("");
    onClose();
  };

  return (
    <Dialog show={isOpen} onClose={handleClose}>
      <DialogTitle>Informe seu CPF</DialogTitle>
      <DialogDescription>
        Sua conta Google não foi encontrada. Informe seu CPF para verificarmos
        seu cadastro no iSeduc e criar sua conta automaticamente.
      </DialogDescription>

      <form onSubmit={handleSubmit}>
        <FormRow>
          <FormLabel htmlFor="google-cpf">CPF</FormLabel>
          <InputMask
            id="google-cpf"
            name="google-cpf"
            mask="___.___.___-__"
            replacement={{ _: /\d/ }}
            value={cpf}
            onChange={(e) => setCpf(e.target.value)}
            placeholder="000.000.000-00"
            className={`${formStyles.control}${error ? ` ${formStyles.invalid}` : ""}`}
            autoFocus
          />
          {error && <FormFeedback invalid>{error}</FormFeedback>}
        </FormRow>

        <DialogFooter>
          <Button
            modifiers={["outline", "full"]}
            type="submit"
            disabled={loading}
          >
            {loading ? "Verificando..." : "Confirmar"}
          </Button>
        </DialogFooter>
      </form>
    </Dialog>
  );
}
